
import Vue from 'vue';
import { mapGetters } from 'vuex';
import type { Location } from 'vue-router';
import BravadoText from '~/components/common/BravadoText/BravadoText.vue';
import BravadoButtonV3 from '~/components/common/BravadoButtonV3/BravadoButtonV3.vue';
import CloseIcon from '~/assets/svg/close.vue.svg';
import type { IDeal } from '~/types/community';
import { numberToDelimited } from '~/components/utils/core/number';
import { categoryNames } from '~/components/partials/war-room/WarRoomPostForm/WarRoomPostFormCategories/constants';
import BravadoTheme from '~/components/common/BravadoTheme/BravadoTheme.vue';

export default Vue.extend({
  name: 'GongAnimation',
  components: { BravadoText, BravadoButtonV3, BravadoTheme, CloseIcon },
  data() {
    return {
      mounted: false,
      animationFinished: false,
      options: {
        animationData: null,
        autoplay: true,
        loop: false,
        renderer: 'svg',
      },
    };
  },
  computed: {
    ...mapGetters('deals', { dealsList: 'deals' }),
    deal(): IDeal | undefined {
      return (this.dealsList as IDeal[]).find(d => d.id === Number(this.$route.query['deal-id']));
    },
    dealLink(): string {
      return this.deal?.post ? `${this.$pages.POSTS_PAGE.path}/${this.deal!.post!.slug}` : '';
    },
    dealAmount(): string {
      return this.deal?.amount ? numberToDelimited(this.deal?.amount) : '';
    },
    newDealLink(): Location {
      return { name: this.$pages.WAR_ROOM_POSTS_NEW_PAGE.name, query: { category: categoryNames.WIN_WIRE } };
    },
  },
  mounted() {
    setTimeout(() => {
      // @ts-ignore types for vue-lottie
      Promise.all([import('vue-lottie'), import('./assets/animation.json')]).then(([VueLottie, animationData]) => {
        this.mounted = true;
        // @ts-ignore json is not assignable to null
        this.options.animationData = animationData.default;
        // @ts-ignore Object is possibly 'undefined'
        this.$options.components.VueLottie = VueLottie.default;
      });
    }, 250);
  },
  methods: {
    onAnimCreated(animation: { addEventListener: (event: string, cb: () => void) => void }) {
      animation.addEventListener('complete', () => {
        this.animationFinished = true;
      });
    },
  },
});
